import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { CONTACT, ASSETS } from "@/constants/site";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10 pt-16 pb-8">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <img src={ASSETS.logo} alt="Trom Motors" className="trom-logo h-20 w-auto object-contain" />
              <div>
                <div className="font-heading text-white text-lg uppercase tracking-wide">Trom Motors LLC</div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-[#F5B800] font-bold">NAICS 423830</div>
              </div>
            </div>
            <p className="mt-6 text-neutral-500 text-sm max-w-xs leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.3em] text-neutral-500 font-bold mb-4">{t.footer.quick}</div>
            <ul className="space-y-3 text-sm">
              <li><a href="#about" className="text-neutral-300 hover:text-[#F5B800] transition-colors">{t.nav.about}</a></li>
              <li><a href="#capabilities" className="text-neutral-300 hover:text-[#F5B800] transition-colors">{t.nav.capabilities}</a></li>
              <li><a href="#fleet" className="text-neutral-300 hover:text-[#F5B800] transition-colors">{t.nav.fleet}</a></li>
              <li><a href="#contact" className="text-neutral-300 hover:text-[#F5B800] transition-colors">{t.nav.contact}</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[10px] uppercase tracking-[0.3em] text-neutral-500 font-bold mb-4">{t.footer.contact}</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={14} className="text-[#F5B800] mt-1 flex-shrink-0" />
                <span className="text-neutral-300">{t.contact.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={14} className="text-[#F5B800] mt-1 flex-shrink-0" />
                <a href={CONTACT.phoneHref} className="text-neutral-300 hover:text-[#F5B800] transition-colors">{CONTACT.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={14} className="text-[#F5B800] mt-1 flex-shrink-0" />
                <a href={CONTACT.emailHref} className="text-neutral-300 hover:text-[#F5B800] transition-colors">{CONTACT.email}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[11px] uppercase tracking-[0.25em] text-neutral-600 font-bold">
          <div>© {year} Trom Motors LLC. {t.footer.rights}</div>
          <div>Doral • Florida • USA</div>
        </div>
      </div>
    </footer>
  );
}
